export default __webpack_public_path__ + "static/media/9a4d48a6eb4f5f76.deb14789752a49e6e8ec2b31e323791d.svg";